<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="developmentList" formControlName="developmentId" optionLabel="adrDevelopmentName"
            optionValue="developmentId" placeholder="Select Development" appendTo="body"></p-dropdown>
            <label for="Development">Select Development</label>
            @for (validation of validationMessages.developmentId; track validation) {
              <span>
                @if (form1.get('developmentId').hasError(validation.type) && (form1.get('developmentId').dirty || form1.get('developmentId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="teaserDesc"><strong>Teaser Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <editor
              formControlName="teaserDesc"
              id="teaserDesc"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.teaserDesc; track validation) {
              <span>
                @if (form1.get('teaserDesc').hasError(validation.type) && (form1.get('teaserDesc').dirty || form1.get('teaserDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="featuresDesc"><strong>Features Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <editor
              formControlName="featuresDesc"
              id="featuresDesc"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.featuresDesc; track validation) {
              <span>
                @if (form1.get('featuresDesc').hasError(validation.type) && (form1.get('featuresDesc').dirty || form1.get('featuresDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <label for="ownerBenefitDesc"><strong>Owner Benefit Description :</strong></label>
          <span class="p-float-label w-100 mb-3">
            <editor
              formControlName="ownerBenefitDesc"
              id="ownerBenefitDesc"
						[init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
            </editor>
            @for (validation of validationMessages.ownerBenefitDesc; track validation) {
              <span>
                @if (form1.get('ownerBenefitDesc').hasError(validation.type) && (form1.get('ownerBenefitDesc').dirty || form1.get('ownerBenefitDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="revenueBenefitDesc" id="revenueBenefitDesc" [rows]="2" pInputTextarea></textarea>
            <label for="revenueBenefitDesc">Revenue Benefit Description</label>
            @for (validation of validationMessages.revenueBenefitDesc; track validation) {
              <span>
                @if (form1.get('revenueBenefitDesc').hasError(validation.type) && (form1.get('revenueBenefitDesc').dirty || form1.get('revenueBenefitDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="mainBenefitDesc" id="mainBenefitDesc" [rows]="2" pInputTextarea></textarea>
            <label for="mainBenefitDesc">Main Benefit Description</label>
            @for (validation of validationMessages.mainBenefitDesc; track validation) {
              <span>
                @if (form1.get('mainBenefitDesc').hasError(validation.type) && (form1.get('mainBenefitDesc').dirty || form1.get('mainBenefitDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="hskpBenefitDesc" id="hskpBenefitDesc" [rows]="2" pInputTextarea></textarea>
            <label for="hskpBenefitDesc">Hskp Benefit Description</label>
            @for (validation of validationMessages.hskpBenefitDesc; track validation) {
              <span>
                @if (form1.get('hskpBenefitDesc').hasError(validation.type) && (form1.get('hskpBenefitDesc').dirty || form1.get('hskpBenefitDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="mgmtRate" id="mgmtRate" type="number" pInputText>
            <label for="mgmtRate">Menagement Rate</label>
            @for (validation of validationMessages.mgmtRate; track validation) {
              <span>
                @if (form1.get('mgmtRate').hasError(validation.type) && (form1.get('mgmtRate').dirty || form1.get('mgmtRate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="questionAnswerId" id="questionAnswerId" type="number" pInputText>
            <label for="questionAnswerId">Question Answer ID</label>
            @for (validation of validationMessages.questionAnswerId; track validation) {
              <span>
                @if (form1.get('questionAnswerId').hasError(validation.type) && (form1.get('questionAnswerId').dirty || form1.get('questionAnswerId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (ownerMgmtCmsId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete OwnerMgmtCms</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!ownerMgmtCmsId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add OwnerMgmtCms</button>
              }

              @if (ownerMgmtCmsId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update OwnerMgmtCms</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>